//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
export default {
  // (SelectArr为下拉框参数,SelectValue为当前选中值,widths为组件宽度)
  props: ['SelectArr', 'SelectValue', 'widths', 'index'],
  data: function data() {
    return {
      //自定义输入框的值
      modifySelectValue: '',
      //下拉框改变成输入框控制参数
      showInputValue: false,
      //接受父组件传过来的值
      DataSelectValue: this.SelectValue,
      myInputTpe: ''
    };
  },
  methods: {
    //选择自定义显示输入框
    showInput: function showInput(value) {
      if (value === "自定义") {
        this.showInputValue = true;
      }

      if (value !== '自定义') {
        console.log('DataSelectValue');
        console.log(this.DataSelectValue);
        this.$emit('GetSelectValue', this.DataSelectValue, this.index);
      } // console.log(value)

    },
    //输入框失去焦点回复下拉框并赋值
    noneInput: function noneInput() {
      this.showInputValue = false; //自定义选项赋值

      this.DataSelectValue = this.modifySelectValue;
      this.$emit('GetSelectValue', this.DataSelectValue, this.index);
    }
  },
  watch: {
    SelectValue: {
      handler: function handler(newValue, oloValue) {
        if (oloValue === undefined && newValue) {
          this.DataSelectValue = newValue;
        }
      },
      deep: true
    }
  },
  directives: {
    focus: {
      //自定义获取焦点指令
      inserted: function inserted(el) {
        el.querySelector('input').focus();
      }
    }
  }
};